module.exports = function () {
  var sharedOptions = {
    id: `letenky.cz`,
    hostname: '//olymp9.sa.cz/shared/'

  };
  var options = {
    letenky: {
      maxRoutes: 5,
      formType: 'round_trip'
    },
    pojisteni: {}
  };

  Object.keys(options).forEach((key) => {
    options[key] = $.extend({}, sharedOptions, options[key]);
  });

  return options;

};



// WEBPACK FOOTER //
// ./src/js/homepage/widget-defaults.js